import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "recipe-detail-page" }
const _hoisted_2 = {
  key: 0,
  class: "recipe-detail"
}
const _hoisted_3 = { class: "recipe-header" }
const _hoisted_4 = { class: "header-content" }
const _hoisted_5 = { class: "recipe-meta" }
const _hoisted_6 = { class: "meta-item" }
const _hoisted_7 = { class: "meta-text" }
const _hoisted_8 = { class: "meta-item" }
const _hoisted_9 = { class: "meta-text" }
const _hoisted_10 = { class: "header-actions" }
const _hoisted_11 = { class: "recipe-content" }
const _hoisted_12 = { class: "recipe-image-section" }
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = { class: "image-info" }
const _hoisted_15 = { class: "info-card" }
const _hoisted_16 = { class: "stats-grid" }
const _hoisted_17 = { class: "stat" }
const _hoisted_18 = { class: "stat-value" }
const _hoisted_19 = { class: "stat" }
const _hoisted_20 = { class: "stat-value" }
const _hoisted_21 = { class: "recipe-info-section" }
const _hoisted_22 = { class: "ingredients-section" }
const _hoisted_23 = { class: "section-heading" }
const _hoisted_24 = { class: "instructions-section" }
const _hoisted_25 = { class: "section-heading" }
const _hoisted_26 = { class: "instructions-content" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = {
  key: 1,
  class: "recipe-not-found"
}
const _hoisted_29 = { class: "not-found-content" }

import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import {
  Edit,
  Back,
  Calendar,
  User,
  List,
  Document,
  Lock,
} from '@element-plus/icons-vue';
import { useRecipeStore } from '@/stores/recipe';
import { useUIStore } from '@/stores/ui';
import { useAuthStore } from '@/stores/auth';
import { canUserModifyRecipe } from '@/utils/recipeUtils';
import DifficultyBadge from '@/components/ui/DifficultyBadge.vue';
import IngredientsList from '@/components/recipe/IngredientsList.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'RecipeDetail',
  setup(__props) {

const recipeStore = useRecipeStore();
const uiStore = useUIStore();
const authStore = useAuthStore();
const route = useRoute();

const recipe = computed(() => recipeStore.currentRecipe);

// Check if current user can edit this recipe
const canEditRecipe = computed(() => {
  return canUserModifyRecipe(recipe.value, authStore.user);
});

const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

const formatInstructions = (instructions: string) => {
  return instructions.replace(/\n/g, '<br>');
};

const handleImageError = (event: Event) => {
  const target = event.target as HTMLImageElement;
  target.src = 'https://picsum.photos/400/250?random=1001';
};

onMounted(() => {
  if (route.params.id) {
    recipeStore.fetchRecipe(route.params.id as string);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (recipe.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", null, _toDisplayString(recipe.value.title), 1),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(DifficultyBadge, {
                  difficulty: recipe.value.difficulty
                }, null, 8, ["difficulty"]),
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_unref(Calendar), { class: "meta-icon" }),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(formatDate(recipe.value.createdDate)), 1)
                ]),
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_unref(User), { class: "meta-icon" }),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(recipe.value.creatorName), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              (canEditRecipe.value)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    class: "custom-button",
                    size: "large",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/edit/' + recipe.value.id)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Edit)),
                      _cache[4] || (_cache[4] = _createTextVNode(" Edit Recipe "))
                    ]),
                    _: 1,
                    __: [4]
                  }))
                : (!_unref(authStore).isAuthenticated)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "primary",
                      class: "custom-button",
                      size: "large",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/login')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Lock)),
                        _cache[5] || (_cache[5] = _createTextVNode(" Login to Create Recipes "))
                      ]),
                      _: 1,
                      __: [5]
                    }))
                  : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                class: "custom-button-secondary",
                size: "large",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Back)),
                  _cache[6] || (_cache[6] = _createTextVNode(" Back to Home "))
                ]),
                _: 1,
                __: [6]
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("img", {
                src: recipe.value.imageUrl,
                alt: recipe.value.title,
                class: "recipe-image",
                onError: handleImageError
              }, null, 40, _hoisted_13),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[9] || (_cache[9] = _createElementVNode("h4", null, "Recipe Stats", -1)),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "stat-label" }, "Ingredients", -1)),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(recipe.value.ingredientCount || recipe.value.ingredients?.length || 0), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "stat-label" }, "Difficulty", -1)),
                      _createElementVNode("span", _hoisted_20, _toDisplayString(recipe.value.difficulty), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("h3", _hoisted_23, [
                  _createVNode(_unref(List), { class: "section-icon" }),
                  _cache[10] || (_cache[10] = _createElementVNode("span", null, "Ingredients", -1))
                ]),
                _createVNode(IngredientsList, {
                  ingredients: recipe.value.ingredients || [],
                  editable: false
                }, null, 8, ["ingredients"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("h3", _hoisted_25, [
              _createVNode(_unref(Document), { class: "section-icon" }),
              _cache[11] || (_cache[11] = _createElementVNode("span", null, "Instructions", -1))
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("p", {
                innerHTML: formatInstructions(recipe.value.instructions)
              }, null, 8, _hoisted_27)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _cache[13] || (_cache[13] = _createElementVNode("h2", null, "Recipe not found", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("p", null, "The recipe you're looking for doesn't exist or has been removed.", -1)),
            _createVNode(_component_el_button, {
              type: "primary",
              class: "custom-button",
              size: "large",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/')))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Back)),
                _cache[12] || (_cache[12] = _createTextVNode(" Back to Home "))
              ]),
              _: 1,
              __: [12]
            })
          ])
        ]))
  ])), [
    [_directive_loading, _unref(uiStore).isLoading]
  ])
}
}

})